export const COOKIE_LOCALE_NAME = 'localeCookieNotice';
export const COOKIE_VALUE = 'true';
